import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/errors";
import { Button, Field, InlineNote } from "./ds";
import { AuthHeading, AuthLayout, SwitchLink } from "./auth/AuthLayout";
import AndroidAppLink from "./auth/AndroidAppLink";
import GoogleButton from "./auth/GoogleButton";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const response = await authAPI.login(email, password);
      login({ email, id: response.user_id || null, tier: response.tier || "lapsed_tier" });
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      setError(formatApiError(err, "Invalid email or password"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <AuthHeading title="Welcome back" subtitle="Sign in to see your week." />

      <div className="flex flex-col gap-4">
        <form onSubmit={handleEmailLogin} className="flex flex-col gap-4">
          {error && <InlineNote tone="error" text={error} />}
          <Field label="Email" type="email" inputMode="email" autoComplete="email" placeholder="you@example.com"
            value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Field label="Password" type="password" autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)} required />
          <div className="flex justify-end">
            <Link to="/forgot-password" className="type-label text-accent-default hover:text-accent-hover">Forgot password?</Link>
          </div>
          <Button type="submit" block loading={isLoading}>Sign in</Button>
        </form>

        <GoogleButton />

        <SwitchLink prompt="New to Aithlo?" to="/register" label="Create an account" />
        <AndroidAppLink />
      </div>
    </AuthLayout>
  );
};

export default Login;
